export default __webpack_public_path__ + "static/media/paddle.da1226f0.jpg";